module.exports = __webpack_public_path__ + "img/mag-jp.f5d91fda.png";